import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface ValidationResult {
  valid: boolean;
  error: string;
}

export interface ValidationState {
  showErrors: boolean;
  errors: any[];
  customError: string;
}

@Injectable({
  providedIn: 'root'
})
export class EditpdfValidationService {

  validateForm(
    form: FormGroup | undefined,
    checkBoxFields: Record<string, any>,
    radioBoxFields: Record<string, any>,
    formBusinessMapping: Record<string, string>,
    pdfConfig: any,
    ignorePartBValidationOfI9: boolean
  ): ValidationState {
    const state: ValidationState = {
      showErrors: false,
      errors: [],
      customError: ''
    };

    state.errors = this.calculateErrors(form, formBusinessMapping);
    if (state.errors.length > 0) {
      state.showErrors = true;
    }

    state.customError = '';
    Object.entries(checkBoxFields).forEach(([key, values]) => {
      let value = '';
      values.forEach((v: any) => {
        v.childFields.forEach((cf: any) => {
          const inputValue = form?.get(cf.fieldId)?.value;
          if (value == '' && inputValue != 'Off') {
            value = inputValue;
          }
        });
      });

      if (value == '') {
        state.customError = 'Please select ' + key + ' details';
      }
    });
    state.showErrors = state.customError != '' || !form?.valid;

    if (!state.showErrors) {
      state.customError = '';
      Object.entries(radioBoxFields).forEach(([key, values]) => {
        let value = '';
        values.forEach((v: any) => {
          v.childFields.forEach((cf: any) => {
            const inputValue = form?.get(cf.fieldId)?.value;
            if (value == '' && inputValue != 'Off') {
              value = inputValue;
            }
          });
        });

        if (value == '') {
          state.customError = 'Please select ' + key + ' details';
        }
      });
      state.showErrors = state.customError != '' || !form?.valid;
    }

    if (!state.showErrors) {
      this.validateCustomLogic(form, pdfConfig, ignorePartBValidationOfI9, checkBoxFields, state);
    }

    return state;
  }

  validateCustomLogic(
    form: FormGroup | undefined,
    pdfConfig: any,
    ignorePartBValidationOfI9: boolean,
    checkBoxFields: Record<string, any>,
    state: ValidationState
  ): void {
    if (pdfConfig?.form_id == '109') {

      if (!ignorePartBValidationOfI9) {
        let isPartAInValid = !form?.value['List A Document Title 1'] || !form?.value['List A Issuing Authority 1'];
        let isPartBCInValid = !form?.value['List B Document Title'] ||
          !form?.value['List B Issuing Authority'] ||
          !form?.value['List C Document Title'] || !form?.value['List C Issuing Authority'];

        if (isPartAInValid && isPartBCInValid) {
          state.showErrors = true;
          state.customError = "Document Title 1 and Issuing Authority are required";
        } else {

          let isLastNameFirstName = !form?.value['Employer Last Name First Name'];
          let orgAddressIsInvalid = !form?.value['Employer Business Address'];
          let todayDateIsInvalid = !form?.value['Todays Date'];
          let dateOfEmploymentIsInvalid = !form?.value['First Day of Employment'];

          if (isLastNameFirstName) {
            state.showErrors = true;
            state.customError = "Last Name First Name and Title of Employer or Authorized Representative is required";
          }
          else if (orgAddressIsInvalid) {
            state.showErrors = true;
            state.customError = "Employers Business or Org Address is required";
          } else if (todayDateIsInvalid) {
            state.showErrors = true;
            state.customError = "Today's Date is required";
          }
          else if (dateOfEmploymentIsInvalid) {
            state.showErrors = true;
            state.customError = "First Day of Employment is required";
          }

          if (!todayDateIsInvalid && this.isInvalidDate(form?.value['Todays Date'])) {
            state.showErrors = true;
            state.customError = "Today's date has an invalid value, or is not in the mm/dd/yyyy format.";
          }

          if (!dateOfEmploymentIsInvalid && this.isInvalidDate(form?.value['First Day of Employment'])) {
            state.showErrors = true;
            state.customError = "First Day of Employment has an invalid value, or is not in the mm/dd/yyyy format.";
          }
        }
      }

      if (form?.value['Citizenship or immigration status'] === "Off") {
        state.showErrors = true;
        state.customError = "Citizenship or immigration status is required";
      }
      else if (form?.value['Citizenship or immigration status'] === "Lawful permanent resident") {
        if (!form?.value['Lawful permanent resident USCIS ANumber']) {
          state.showErrors = true;
          state.customError = "USCIS or A Number is required";
        }
      } else if (form?.value['Citizenship or immigration status'] === "Non citizen authorized to work") {
        let hasEnteredAnyInfo = form?.value['USCIS ANumber'] || form?.value['Form I94 Admission Number'] || form?.value['Foreign Passport Number'];
        if (!hasEnteredAnyInfo) {
          state.showErrors = true;
          state.customError = "One of the USCIS - A Number, Form I-94 Admission Number, Foreign Passport Number are required";
        }
      }
    }

    if (pdfConfig?.form_id == '48') {
      let count = 0;
      Object.entries(checkBoxFields).forEach(([key, values]) => {
        values.forEach((v: any) => {
          v.childFields.forEach((cf: any) => {
            const inputValue = form?.get(cf.fieldId)?.value;
            if (inputValue == 'On') {
              count++
            }
          });
        });

        if (count > 1) {
          state.customError = 'Choose only one payment method to proceed.';
        }
      });

      const status = this.validatePaymentForm(form);
      if (!status.valid) {
        state.customError = status.error;
      }
    }

    if (pdfConfig?.form_id && ['110', '122', '128'].includes(pdfConfig?.form_id)) {
      const status = this.validateHCBSAcknowledgement(form);
      if (!status.valid) {
        state.customError = status.error;
      }
    }

    if (pdfConfig?.form_id === '39' || pdfConfig?.form_id === '41') {
      this.validateSSN(form, state);
    }
  }

  validateSSN(form: FormGroup | undefined, state: ValidationState): void {
    console.log("validating ssn")
    const ssnControl = form?.get('Social Security Number');
    const ssnRaw = ssnControl?.value;
    const ssn = ssnRaw ? String(ssnRaw).trim() : '';
    if (ssn && !/^\d+$/.test(ssn)) {
      state.showErrors = true;
      state.customError = 'Please add your Social Security Number. Enter nine numbers only, no dashes (Example: 123456789).';
      return;
    }
    if (ssn && ssn.length !== 9) {
      state.showErrors = true;
      state.customError = 'Please add your Social Security Number. Enter nine numbers only, no dashes (Example: 123456789).';
      return;
    }
  }

  validateHCBSAcknowledgement(form: FormGroup | undefined): ValidationResult {
    const option1 = form?.get(['SDP service meets the HCBS final rule']);
    const option2 = form?.get(['SDP service does not meet the HCBS final rule']);

    if (option1?.value === 'Off' && option2?.value === 'Off') {
      return {
        valid: false,
        error: 'Please select one option for HCBS final rule acknowledgement.'
      };
    } else if (option1?.value === 'On' && option2?.value === 'On') {
      return {
        valid: false,
        error: 'Please select only one option for HCBS final rule acknowledgement.'
      };
    }

    return {
      valid: true,
      error: ''
    };
  }

  validatePaymentForm(form: FormGroup | undefined): ValidationResult {
    const depositToNewBankAccount = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Direct deposit to a Bank Account or ThirdParty Money App"]`);
    const depositToExistingDebitCredit = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Direct Deposit to An Existing Debit Card"]`);

    let isdepositToNewBankAccountChecked = false;
    let isdepositToExistingDebitCreditChecked = false;

    if (depositToNewBankAccount.length) {
      const angularFieldName = form?.get(['Direct deposit to a Bank Account or ThirdParty Money App']);
      const exportValue = depositToNewBankAccount[0].getAttribute('exportvalue');
      isdepositToNewBankAccountChecked = exportValue == angularFieldName?.value ? true : false;
    }
    if (depositToExistingDebitCredit.length) {
      const angularFieldName = form?.get(['Direct Deposit to An Existing Debit Card']);
      const exportValue = depositToExistingDebitCredit[0].getAttribute('exportvalue');
      isdepositToExistingDebitCreditChecked = exportValue == angularFieldName?.value ? true : false;
    }

    if (isdepositToExistingDebitCreditChecked) {
      const textbox4 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Routing number_2"]`);
      const textbox5 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Account number_2"]`);

      if (textbox4.length && textbox4[0] instanceof HTMLInputElement) {
        const routingNumber = textbox4[0].value.trim();

        if (routingNumber === '') {
          return {
            valid: false,
            error: 'Routing number is required for direct deposit to an existing debit card.'
          };
        }

        const validationResult = this.validateRoutingNumber(routingNumber);
        if (!validationResult.valid) {
          return {
            valid: false,
            error: validationResult.error ?? ''
          };
        }
      }

      if (textbox5.length && textbox5[0] instanceof HTMLInputElement) {
        const accountNumber = textbox5[0].value.trim();

        if (accountNumber === '') {
          return {
            valid: false,
            error: 'Account number is required for direct deposit to an existing debit card.'
          };
        }

        const accountRegex = /^\d{6,17}$/;
        if (!accountRegex.test(accountNumber)) {
          return {
            valid: false,
            error: 'Account number must be numeric and between 6 and 17 digits.'
          };
        }
      }
    }

    if (isdepositToNewBankAccountChecked) {
      const checkbox1 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Bank Checking Account"]`);
      const checkbox2 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Thirdparty money app"]`);
      const checkbox3 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Bank Savings Account"]`);
      const textbox1 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Bank or money app name"]`);
      const textbox2 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Routing number"]`);
      const textbox3 = document.querySelectorAll(`.pdfViewer .annotationLayer input[name="Account number"]`);

      let isCheckBox1Checked = false;
      let isCheckBox2Checked = false;
      let isCheckBox3Checked = false;
      if (checkbox1.length && checkbox1[0] instanceof HTMLInputElement) {
        isCheckBox1Checked = checkbox1[0].checked;
      }
      if (checkbox2.length && checkbox2[0] instanceof HTMLInputElement) {
        isCheckBox2Checked = checkbox2[0].checked;
      }
      if (checkbox3.length && checkbox3[0] instanceof HTMLInputElement) {
        isCheckBox3Checked = checkbox3[0].checked;
      }

      const checkedCount = [isCheckBox1Checked, isCheckBox2Checked, isCheckBox3Checked].filter(Boolean).length;

      if (checkedCount != 1) {
        return { valid: false, error: 'Select one account type for direct deposit to a bank account or third-party money app.' };
      }
      if (textbox1.length && textbox1[0] instanceof HTMLInputElement && textbox1[0].value.trim() == '') {
        return { valid: false, error: 'Bank or money app name is required for direct deposit to a bank account or third-party money app.' };
      }
      if (textbox2.length && textbox2[0] instanceof HTMLInputElement) {
        const routingNumber = textbox2[0].value.trim();

        if (routingNumber === '') {
          return {
            valid: false,
            error: 'Routing number is required for direct deposit to a bank account or third-party money app.'
          };
        }

        const validationResult = this.validateRoutingNumber(routingNumber);
        if (!validationResult.valid) {
          return {
            valid: false,
            error: validationResult.error ?? ''
          };
        }
      }
      if (textbox3.length && textbox3[0] instanceof HTMLInputElement) {
        const accountNumber = textbox3[0].value.trim();

        if (accountNumber === '') {
          return {
            valid: false,
            error: 'Account number is required for direct deposit to a bank account or third-party money app.'
          };
        }

        const accountRegex = /^\d{6,17}$/;
        if (!accountRegex.test(accountNumber)) {
          return {
            valid: false,
            error: 'Account number must be numeric and between 6 and 17 digits.'
          };
        }
      }
    }

    return { valid: true, error: '' };
  }

  calculateErrors(form: FormGroup | undefined, formBusinessMapping: Record<string, string>): any[] {
    let errors: any[] = [];
    Object.keys(form?.value).forEach(field => {
      const control = form?.get(field);
      if (control) {
        const controlErrors = control.errors;
        if (controlErrors !== null) {
          Object.keys(controlErrors).forEach(keyError => {
            errors.push({
              controlName: field,
              errorName: keyError,
              errorValue: controlErrors[keyError],
              businessName: formBusinessMapping[field]
            });
          });
        }
      }
    });

    errors = errors.filter((error: any, index: any, self: any) => self.findIndex((t: any) => {
      return t.controlName === error.controlName && t.errorName === error.errorName;
    }) === index);

    return errors;
  }

  isInvalidDate(dateString: string): boolean {
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (!dateString || !regex.test(dateString)) {
      return true;
    }

    const [month, day, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const isValid = date.getMonth() === month - 1 && date.getDate() === day;
    return !isValid;
  }

  getTodayDate(): string {
    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const year = today.getFullYear();
    return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
  }

  validateRoutingNumber(routingNumber: string): { valid: boolean; error?: string } {
    const regex = /^\d{9}$/;
    if (!regex.test(routingNumber)) {
      return {
        valid: false,
        error: "Routing number must be exactly 9 numeric digits.",
      };
    }

    const digits = routingNumber.split('').map(Number);

    const checksum =
      (digits[0] + digits[3] + digits[6]) * 3 +
      (digits[1] + digits[4] + digits[7]) * 7 +
      (digits[2] + digits[5] + digits[8]) * 1;

    if (checksum % 10 !== 0) {
      return {
        valid: false,
        error: "Invalid routing number: ABA checksum validation failed.",
      };
    }

    return { valid: true };
  }
}
